export default __webpack_public_path__ + "static/flag-capture-light-e5a016d13c229d60193ae9bf04393820.png";